// extracted by mini-css-extract-plugin
export default {"containerDefault":"NoTransactions_containerDefault__BjRtv","headerDefault":"NoTransactions_headerDefault__fYEhK","descriptionDefault":"NoTransactions_descriptionDefault__LvYU2"};